import { render, staticRenderFns } from "./CustomerPortal.vue?vue&type=template&id=3714f46b&scoped=true&"
import script from "./CustomerPortal.vue?vue&type=script&lang=js&"
export * from "./CustomerPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3714f46b",
  null
  
)

export default component.exports